import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
import Logos from '../pages/image/favicon-32x32.png'
// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <img src={Logos} alt='logo'/>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/dashboard/dashboard">{logo}</RouterLink>;
}
